import Resize from '@/mixins/Resize'

const LABELS = ['name', 'mail', 'company']
const STATES = {
    // INIT: 'init',

    NAME: LABELS[0],
    MAIL: LABELS[1],
    COMPANY: LABELS[2],
    MESSAGE: 'message',

    SUCCESS: 'success',
    ERROR: 'error'
}

export default {

    name: 'contact',

    mixins: [
        Resize
    ],

    data()
    {
        return {
            STATES,
            state: LABELS[0],
            isPhoneIntro: true,

            name: '',
            mail: '',
            company: '',
            message: ''
        }
    },

    watch:
    {
        state(state)
        {
            if (state !== LABELS[0])
            {
                this.isPhoneIntro = false
            }

            if (state === STATES.MESSAGE)
            {
                this.$nextTick(this.resizeMessage)

                // Set focus on current input
                const next = () => this.$refs.message.focus()
                this.$nextTick(next)
            }

            if (LABELS.indexOf[state] > -1)
            {
                // Set focus on current input
                const next = () => this.$refs[state].focus()
                this.$nextTick(next)
            }
        }
    },

    methods:
    {
        start()
        {
            this.isPhoneIntro = false
        },

        back()
        {
            this[this.state] = ''
            if (this.state === STATES.NAME)
            {
                this.isPhoneIntro = true
            }
            else if (LABELS.indexOf(this.state) > -1)
            {
                const keys = Object.keys(STATES)
                const key = keys.find(key => STATES[key] === this.state)
                const keyID = keys.indexOf(key)
                this.state = STATES[keys[keyID - 1]]
            }
        },

        next()
        {
            if (this.state === STATES.INIT)
            {
                this.state = LABELS[0]
            }
            else if (LABELS.indexOf(this.state) > -1 && this[this.state] !== '')
            {
                const keys = Object.keys(STATES)
                const key = keys.find(key => STATES[key] === this.state)
                const keyID = keys.indexOf(key)
                this.state = STATES[keys[keyID + 1]]
            }
        },

        remove(state)
        {
            this[state] = ''
            this.state = state
        },

        send()
        {
            const content = {
                Leads: {
                    Name: this.name,
                    Email: this.mail,
                    Company: this.company,
                    Message: this.message
                }
            }

            fetch('/api/add-lead.php', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify(content)
            })
                .then(res =>
                {
                    if (res.status !== 200)
                    {
                        throw new Error('Server disconnected')
                    }
                    else
                    {
                        return res
                    }
                })
                .then(() => this.state = STATES.SUCCESS)
                .catch(res =>
                {
                    console.error(res)
                    this.state = STATES.ERROR
                })
        },

        onResized()
        {
            this.resizeMessage()
        },

        resizeMessage()
        {
            const message = this.$refs.message
            if (message)
            {
                message.style.cssText = 'height:auto;padding:0'
                const height = (Number(message.scrollHeight) + 20)

                if (height < 182)
                {
                    message.style.cssText = 'overflow:hidden;height:' + height + 'px;'
                }
                else
                {
                    message.style.cssText = 'height:182px;'
                }
            }
        }
    }
}
